// Catch Ups Page
export const CATCHUPS_PAGE_TITLE = 'Catch-Ups';
export const CATCHUPS_PAGE__TABLE_HEADER__DISPLAY_ID = 'Catch-Up ID';
export const CATCHUPS_PAGE__TABLE_HEADER__AMOUNT = 'Amount';
export const CATCHUPS_PAGE__TABLE_HEADER__STATUS = 'Status';
export const CATCHUPS_PAGE__TABLE_HEADER__CREATED_DATE = 'Date Created';

export const CATCHUPS_PAGE__TABLE_ACTION__DOWNLOAD = 'Download Catch-Up';
export const CATCHUPS_PAGE__TABLE_ACTION__COPY = 'Copy Catch-Up Locator';
export const CATCHUPS_PAGE__TABLE_ACTION__COPY__SUCCESS =
	'Catch-Up locator copied to clipboard';
export const CATCHUPS_PAGE__TABLE_ACTION__REVERSE = 'Reverse Payment';
export const CATCHUPS_PAGE__TABLE_ACTION__PAY = 'Pay Catch-Up';
export const CATCHUPS_PAGE__TABLE_ACTION__WRITE_OFF = 'Write Off';
export const CATCHUPS_PAGE__TABLE_ACTION__INVALIDATE = 'Invalidate Catch-Up';
export const CATCHUPS_PAGE__CREATE_BUTTON = 'Issue Catch-Up';

// Catch-Up Page
export const CATCHUP_PAGE__TITLE = (catchUpId: string) =>
	`Catch-up ${catchUpId}`;
export const CATCHUP_PAGE__CATCHUP_NOT_FOUND = 'Catch-Up not found';
export const CATCHUP_PAGE__CATCHUP_NOT_FOUND_ACTION_TEXT = 'Go Back';
export const CATCHUP_PAGE__AMOUNT_DUE_TITLE = 'Amount Due';
export const CATCHUP_PAGE__ISSUE_DATE_TITLE = 'Issue Date';
export const CATCHUP_PAGE__DUE_DATE_TITLE = 'Due Date';
export const CATCHUP_PAGE__STATUS_TITLE = 'Status';
export const CATCHUP_PAGE__POLICY_TITLE = 'Policy';
export const CATCHUP_PAGE__POLICYHOLDER_TITLE = 'Policyholder';

// Catch-Up Page Actions
export const CATCHUP_PAGE__DOWNLOAD_ACTION = 'Download Catch-Up';
export const CATCHUP_PAGE__COPY_ACTION = 'Copy Catch-Up Locator';
export const CATCHUP_PAGE__COPY_ACTION__SUCCESS_TOAST =
	'Catch-Up locator copied to clipboard';
export const CATCHUP_PAGE__PAY_ACTION = 'Pay Catch-Up';
export const CATCHUP_PAGE__WRITEOFF_ACTION = 'Write Off';
export const CATCHUP_PAGE__WRITEOFF_ACTION__SUCCESS_TOAST =
	'Successfully wrote off catch-up';
export const CATCHUP_PAGE__WRITEOFF_ACTION__ERROR_TOAST =
	'Failed to write off catch-up';
export const CATCHUP_PAGE__INVALIDATE_ACTION = 'Invalidate Catch-Up';
export const CATCHUP_PAGE__INVALIDATE_ACTION__SUCCESS_TOAST =
	'Successfully invalidated catch-up';
export const CATCHUP_PAGE__INVALIDATE_ACTION__ERROR_TOAST =
	'Failed to invalidate catch-up';
export const CATCHUP_PAGE__REVERSE_ACTION = 'Reverse Payment';
export const CATCHUP_PAGE__REVERSE_ACTION__SUCCESS_TOAST =
	'Successfully reversed payment';
export const CATCHUP_PAGE__REVERSE_ACTION__ERROR_TOAST =
	'Failed to reverse payment';
export const PAY_CATCHUP__SUCCESS_TOAST = 'Successfully paid catch-up';
export const PAY_CATCHUP__ERROR_TOAST = 'Error paying catch-up';

// New Catch Up Page
export const CREATE_CATCH_UP_PAGE__CANCEL = 'Cancel';
export const CREATE_CATCH_UP_PAGE__SUBMIT = 'Issue';
export const CREATE_CATCH_UP_PAGE__TITLE = 'New Catch-Up Invoice';

// Breadcrumbs
export const CATCHUPS_BREADCRUMB = 'Catch-Ups';
export const CATCHUPS_BREADCRUMBS__NEW = 'New';
export const CATCHUPS_BREADCRUMBS__CATCHUP_DISPLAY_ID = (catchUpId: string) =>
	`Catch-Up ${catchUpId}`;

// Catch-up Api
export const CATCHUP_API_MUTATION__ISSUE_SUCCESS_TOAST =
	'Catch-up issued successfully';
export const CATCHUP_API_MUTATION__ISSUE_ERROR_TOAST =
	'Error issuing catch-up ';

// Policyholder Policies Table
export const CREATE_CATCH_UP__SHORTCUT = 'Issue Catch-Up';

// Payments List
export const PAYMENTS_LIST__TITLE = 'Payments';
export const NO_PAYMENTS__MESSAGE = 'No Payments';
export const PAYMENT__DISPLAY_ID = (paymentId: string) =>
	`Payment ${paymentId}`;
export const COPY_PAYMENT__ACTION = 'Copy payment to clipboard';
export const PAYMENT_REVERSED__LABEL = 'Reversed';
export const PAYMENT_DATE__TITLE = 'Payment Date';
export const PAYMENT_AMOUNT__TITLE = 'Payment Amount';
export const REVERSED_DATE__TITLE = 'Reversed Date';

// Invalidate Modal
export const INVALIDATE_INVOICE_MODAL__BUTTON = (isCatchUp?: boolean) =>
	`Invalidate ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const INVALIDATE_INVOICE_MODAL__TITLE = (isCatchUp?: boolean) =>
	`Invalidate ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const INVALIDATE_INVOICE_MODAL__BODY_TEXT_TITLE = (
	invoiceId: string,
	isCatchUp?: boolean,
) => `This will invalidate ${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId}.`;
export const INVALIDATE_INVOICE__TITLE_ERROR = (isCatchUp?: boolean) =>
	`Error Invalidating ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const INVALIDATE_INVOICE_MODAL__BODY_TEXT_TITLE_ERROR = (
	invoiceId: string,
	isCatchUp?: boolean,
) => `Failed to invalidate ${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId}.`;
export const INVALIDATE_INVOICE_MODAL__BODY_TEXT_TITLE_SUCCESS = (
	invoiceId: string,
	isCatchUp: boolean,
) => `${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId} has been invalidated.`;
export const INVALIDATE_INVOICE__TRY_AGAIN = 'Try Again';
export const INVALIDATE_INVOICE__TITLE_SUCCESS = (isCatchUp?: boolean) =>
	`${isCatchUp ? 'Catch-Up' : 'Invoice'} Invalidated`;
export const INVALIDATE_INVOICE_MODAL__LOADING = (isCatchUp?: boolean) =>
	`Invalidating ${isCatchUp ? 'Catch-Up' : 'Invoice'}...`;
export const INVALIDATE_INVOICE_MODAL__SUBMIT = (isCatchUp?: boolean) =>
	`Invalidate ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const INVALIDATE_INVOICE_MODAL__CANCEL = 'Cancel';
export const INVALIDATE_INVOICE_MODAL__DONE = 'Done';
